<div class="p-3 modal-atributos">
  <div class="modal-atributos-wrapper" mat-dialog-content>
    <div class="d-flex justify-content-between">

      <h1 class="modal-atributos-title" mat-dialog-title>Atributos</h1>

      <span class="return-to-search-btn " >
        <button class="btn btn-light" (click)="return()">
          <i class="bi bi-reply-fill"></i>
        </button>
      </span>
    </div>

    <div *ngIf="data.length <= 0">
      <span class="modal-atributos-not-message">Desculpe, não encontramos nunhum atributo cadastrado!</span>
    </div>
    <div *ngIf="data.length > 0">
      <table class="modal-atributos-table" *ngFor="let dt of data">
        <thead>
        <tr>
          <th class="modal-atributos-key">
            <span>{{dt.nome}}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="modal-atributos-value">
            <span>{{dt.valor}}</span>
          </td>
        </tr>
      </tbody>
      </table>
    </div>
  </div>
</div>

